<div class="search-mode-toggle-inline" role="group" aria-label="Search mode">
    <button type="button" [class.active]="mode === 'magic'" [attr.aria-pressed]="mode === 'magic'" aria-label="AI search" (click)="select('magic')">
        <img src="assets/imgs/magic-search/sparkles.svg" width="11px" height="11px" alt="" aria-hidden="true" />
        AI
    </button>
    <button type="button" [class.active]="mode === 'classic'" [attr.aria-pressed]="mode === 'classic'" aria-label="Classic search" (click)="select('classic')">Cl</button>
</div>
